import Vue from 'vue'
import VueResource from 'vue-resource'
import {API_METADATA, API_PROFILES} from '@/constants.js'
import {API_PROFILES_GENERAL, API_PROFILES_SIP} from '../constants'

Vue.use(VueResource)

// API base data
const metadataUri = API_METADATA + '/'
const factsheetUri = API_PROFILES + '/'

// Nested categories in 'profiles'
const profilesGeneralUri = factsheetUri + API_PROFILES_GENERAL + '/'
const profilesSipUri = factsheetUri + API_PROFILES_SIP + '/'

// resource is only requested in production version
const SessionKeyResource = Vue.resource('getUniqueSessionId')

// API lookups for sets of metadata
const IndicatorResource = Vue.resource(metadataUri + 'indicators')
const CountryResource = Vue.resource(metadataUri + 'countries')
const RegionResource = Vue.resource(metadataUri + 'regions')
const TopicResource = Vue.resource(metadataUri + 'topics')
// we have also a source for normalization types now
const NormalizationResource = Vue.resource(metadataUri + 'normalization')
// topics_descendants became classes_descendants but api end is unavailable right now
// (it is probably a typo, topics_descendants still works)
const OntologyResource = Vue.resource(metadataUri + 'topics_descendants')
// keywords aren't available on v5
// const KeywordResource = Vue.resource(metadataUri + 'keywords')
const YearResource = Vue.resource(metadataUri + 'years')
const CountryRegionResource = Vue.resource(metadataUri + 'country_region')

// API lookups for profile information a.k.a. fact sheets
const CountryProfileResource = Vue.resource(profilesGeneralUri + 'country')
const RegionProfileResource = Vue.resource(profilesGeneralUri + 'region')
const TopicProfileResource = Vue.resource(profilesGeneralUri + 'topic')
// SIP end points
const sipsMinimalResource = Vue.resource(profilesSipUri + 'general')
const sipsFullResource = Vue.resource(profilesSipUri + 'detail')

// const ACCESS_TOKEN = 'access_token'
// const REFRESH_TOKEN = 'refresh_token'

export default {
  // return identifier for the current session
  getSessionKey: () => {
    return SessionKeyResource.get()
  },
  // lookup data
  getIndicators: () => {
    return IndicatorResource.get()
  },
  getCountries: () => {
    return CountryResource.get()
  },
  getRegions: () => {
    return RegionResource.get()
  },
  getTopics: () => {
    return TopicResource.get()
  },
  getNormalization: () => {
    return NormalizationResource.get()
  },
  getOntology: () => {
    return OntologyResource.get()
  },
  // TODO: tthere is no keyword resource in v5?
  //  getKeywords: () => {
  //    return KeywordResource.get()
  //  },
  getYears: () => {
    return YearResource.get()
  },
  getCountriesRegions: () => {
    return CountryRegionResource.get()
  },
  getCountryProfile: (sessionKey, country, year, complement = null, complementItem = null, filterByComplement = false) => {
    let filters = {
      session: sessionKey,
      country: country,
      year: year
    }
    if (filterByComplement) {
      filters[complement.dimensionName] = complementItem.code
    }
    return CountryProfileResource.get(filters)
  },
  getRegionProfile: (sessionKey, region, year, complement = null, complementItem = null, filterByComplement = false) => {
    let filters = {
      session: sessionKey,
      region: region,
      year: year
    }
    if (filterByComplement) {
      filters[complement.dimensionName] = complementItem.code
    }
    return RegionProfileResource.get(filters)
  },
  getTopicProfile: (sessionKey, topic, year, complement = null, complementItem = null, filterByComplement = false) => {
    let filters = {
      session: sessionKey,
      topic: topic,
      year: year
    }
    if (filterByComplement) {
      filters[complement.dimensionName] = complementItem.code
    }
    return TopicProfileResource.get(filters)
  },
  // request basic data for SIP Social Innovation Projects based on dimension information (location/topic)
  getSipsMinimal: (sessionKey, groupby, country = null, region = null, topic = null) => {
    let filters = {
      session: sessionKey,
      groupby: groupby.join(',')
    }
    if (topic !== null) {
      filters['topic'] = topic.join(',')
    }
    if (country !== null) {
      filters['country'] = country.join(',')
    }
    if (region !== null) {
      filters['region'] = region.join(',')
    }
    return sipsMinimalResource.get(filters)
  },
  // request fully hydrated SIP objects from API
  getSipsFull: (sessionKey, ids) => {
    let filters = {
      session: sessionKey,
      sip_id: ids.join(',')
    }
    return sipsFullResource.get(filters)
  },
  // request one of the available actors endpoints based on year + dimension information (location/topic)
  // endpoints are: actors_pub/firms_pub, actors_pat/firms_pat, actor_proj/firms_proj
  getActorsMinimal: (sessionKey, actorsEndpoint, grouping, year = 0, country = null, region = null, topic = null) => {
    let filters = {
      session: sessionKey,
      groupby: grouping.join(','),
      year: year
    }
    if (topic !== null) {
      filters['topic'] = topic.join(',')
    }
    if (country !== null) {
      filters['country'] = country.join(',')
    }
    if (region !== null) {
      filters['region'] = region.join(',')
    }
    return Vue.resource(factsheetUri + actorsEndpoint).get(filters)
  },
  // request fully hydrated actors objects from API
  // endpoints are: actors_detail, firms_detail
  getActorsFull: (sessionKey, actorsEndpoint, ids) => {
    let filters = {
      session: sessionKey,
      actor_id: ids.join(',')
    }
    return Vue.resource(factsheetUri + actorsEndpoint).get(filters)
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js